export default __webpack_public_path__ + "static/media/digital-id-card.ad95d971.png";